import axios from 'axios';
import api from '../config/api';
import { logger } from '../utils/logger';

// Crear instancia de axios con configuración base
const apiClient = axios.create({
  baseURL: api.baseURL,
  timeout: 45000, // Aumentado a 45 segundos para tolerar latencia de túnel Cloudflare en producción
  headers: {
    'Content-Type': 'application/json',
  },
});

// Interceptor para requests
apiClient.interceptors.request.use(
  (config) => {
    logger.log(`Making ${config.method?.toUpperCase()} request to: ${config.baseURL}${config.url}`);
    return config;
  },
  (error) => {
    logger.error('Request error:', error);
    return Promise.reject(error);
  }
);

// Interceptor para responses
apiClient.interceptors.response.use(
  (response) => {
    logger.log(`Received response from: ${response.config.url}`);
    return response;
  },
  (error) => {
    logger.error('Response error:', error);
    if (error.response?.status === 404) {
      logger.error('Endpoint not found - check if backend is running on port 8080');
    }
    return Promise.reject(error);
  }
);

export default apiClient;
